import { render, staticRenderFns } from "./AffiliateCustomerIndex.vue?vue&type=template&id=490b6e75&"
import script from "./AffiliateCustomerIndex.vue?vue&type=script&lang=js&"
export * from "./AffiliateCustomerIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports